import { IBaseModel } from './base/base-model.interface';

export interface IMasterLayoutGuides {
    id: string;
    guides: Array<IGuide>;
}

export interface IGuide {
    type: string;
    /**
     * 参考线方向
     */
    orient: EPpGuideOrientation;

    /**
     * 对齐线颜色
     */
    color: string;

    /**
     * 对齐线位置，沿x/y轴计算
     */
    pos: number;
}

export enum EUpdateGuidesType {
    all = 1,
    slide = 2,
    master = 3,
    layout = 4,
}

export interface IGuideModel {
    /**
     * slide参考线
     */
    slideGuides: Array<IGuide>;

    /**
     * master参考线
     */
    masterGuides: Array<IMasterLayoutGuides>;

    /**
     * layout参考线
     */
    layoutGuides: Array<IMasterLayoutGuides>;

    updateGuidesPropsNoUndo(props, updateGuidesType: EUpdateGuidesType);
}

/**
 * 参考线方向
 */
export enum EPpGuideOrientation {
    /**
     * 水平
     */
    ppHorizontalGuide = 'horz',

    /**
     * 垂直
     */
    ppVerticalGuide = 'vert',
}
